import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useApp } from "../context/AppContext";

export const Footer = () => {
    const { t } = useApp();
    return (
        <footer className="mt-24 border-t border-charcoal/10 bg-forest text-ivory">
            <div className="max-w-7xl mx-auto px-6 sm:px-10 py-14 grid gap-10 md:grid-cols-4">
                <div className="md:col-span-2">
                    <div className="text-2xl"><Logo light /></div>
                    <p className="mt-3 text-ivory/70 max-w-sm text-sm leading-relaxed">{t("hero.tagline")}</p>
                    <p className="mt-4 text-ivory/50 text-xs max-w-sm">WHY-AM is a self-reflection tool, not a medical service or a replacement for professional care.</p>
                </div>
                <div className="text-sm">
                    <p className="uppercase tracking-[0.18em] text-xs text-gold mb-3">Explore</p>
                    <ul className="space-y-2 text-ivory/80">
                        <li><Link to="/how-it-works" className="hover:text-gold">{t("nav.how")}</Link></li>
                        <li><Link to="/about" className="hover:text-gold">{t("nav.about")}</Link></li>
                        <li><Link to="/pricing" className="hover:text-gold">{t("nav.pricing")}</Link></li>
                        <li><Link to="/safety" className="hover:text-gold">{t("nav.safety")}</Link></li>
                    </ul>
                </div>
                <div className="text-sm">
                    <p className="uppercase tracking-[0.18em] text-xs text-gold mb-3">Policies</p>
                    <ul className="space-y-2 text-ivory/80">
                        <li><Link to="/privacy" className="hover:text-gold">Privacy Policy</Link></li>
                        <li><Link to="/terms" className="hover:text-gold">Terms of Service</Link></li>
                        <li><Link to="/refund" className="hover:text-gold">Refund & Cancellation</Link></li>
                        <li><Link to="/contact" className="hover:text-gold">{t("nav.contact")}</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-ivory/10 py-5 text-center text-xs text-ivory/50">
                © {new Date().getFullYear()} WHY-AM. A space to understand yourself, whoever you are.
            </div>
        </footer>
    );
};

export default Footer;
